import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { listJobBoard } from '@/lib/api'
import type { JobBoardRequisition } from '@/types'
import { DataTable, type Column } from '@/components/ui/DataTable'
import { Badge } from '@/components/ui/Badge'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function JobBoardList() {
  const [reqs, setReqs] = useState<JobBoardRequisition[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    listJobBoard().then(setReqs)
  }, [])

  const columns: Column<JobBoardRequisition>[] = [
    { header: 'Agente propuesto', cell: (r) => r.agent_name },
    { header: 'Estado', cell: (r) => <Badge>{r.status.replace('_', ' ')}</Badge> },
    { header: 'Owner', cell: (r) => r.owner ?? '—' },
    { header: 'Creado', cell: (r) => new Date(r.created_at).toLocaleDateString('es-CR') },
  ]

  return (
    <div>
      <PendingBackendNotice endpoint="GET /job-board" />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ fontSize: 20, fontWeight: 500 }}>Job Board</h1>
        <button onClick={() => navigate('/job-board/new')} style={newButtonStyle}>+ Nueva requisición</button>
      </div>
      <DataTable columns={columns} rows={reqs} getRowKey={(r) => r.id} onRowClick={(r) => navigate(`/job-board/${r.id}`)} />
    </div>
  )
}

const newButtonStyle: React.CSSProperties = {
  background: 'var(--surface-raised)',
  border: '1px solid var(--border-strong)',
  color: 'var(--text-primary)',
  borderRadius: 'var(--radius-sm)',
  padding: '6px 12px',
  fontSize: 13,
  cursor: 'pointer',
}
